import type { PoiCategory } from './types';

const FALLBACK: PoiCategory = {
    key: 'default', color: '#2299ff', label_cs: 'Bod zájmu', label_en: 'Point of Interest', filterable: false,
};

let _categories: PoiCategory[] = [];
let _byKey: Record<string, PoiCategory> = {};

export async function loadCategories(): Promise<PoiCategory[]> {
    try {
        const res = await fetch('/api/poi-categories', { credentials: 'same-origin' });
        _categories = await res.json();
    } catch {
        _categories = [FALLBACK];
    }
    _byKey = Object.fromEntries(_categories.map(c => [c.key, c]));
    return _categories;
}

export function getCategories(): PoiCategory[] {
    return _categories;
}

export function getCategory(key: string | undefined | null): PoiCategory {
    return _byKey[key ?? ''] ?? _byKey['default'] ?? FALLBACK;
}

export function getCategoryColor(key: string | undefined | null): number {
    return parseInt(getCategory(key).color.replace('#', ''), 16);
}

export function getCategoryLabel(key: string | undefined | null, lang: string): string {
    const c = getCategory(key);
    return lang === 'cs' ? c.label_cs : c.label_en;
}
